import { MarkerIconType } from 'interfaces/maps.interface';

export interface MetricsResponse {
	data: Data;
}

export interface Data {
	GetProcessMetric: GetProcessMetric;
}

export interface GetProcessMetric {
	responseStatus: ResponseStatus;
	metricSummary: MetricSummary[];
}

export interface MetricSummary {
	metricType: MetricTypesEnum;
	deviceHealth: DeviceHealth[];
	accident: Accident[];
	externalPower: ExternalPower[];
	ignition: Ignition[];
	battery: Battery[];
	network: Network[];
	speedLimit: SpeedLimit[];
	towing: Towing[];
	engine: Engine[];
	sprayer: Sprayer[];
	floatMetrics: FloatMetric[];
	stringMetrics: StringMetric[];
}
export interface ExternalPower {
	externalPowerStatus: 'EXTERNAL_POWER_REMOVED' | 'EXTERNAL_POWER_CONNECTED';
	timeSlot: TimeSlot;
}
export interface Ignition {
	ignitionStatus: string;
	timeSlot: TimeSlot;
}
export interface SpeedLimit {
	speedLimitStatus: string;
	timeSlot: TimeSlot;
}
export interface Towing {
	towingStatus: string;
	timeSlot: TimeSlot;
}
export interface Network {
	networkStatus: 'LOW_SIGNAL_STRENGTH';
	timeSlot: TimeSlot;
}
export interface Accident {
	accidentStatus: AccidentStatus;
	timeSlot: TimeSlot;
}

export interface TimeSlot {
	startTime: Duration;
	duration: Duration;
}

export interface Duration {
	seconds: number;
}

export interface Battery {
	internalBatteryStatus: InternalBatteryStatus;
	timeSlot: TimeSlot;
}

export enum InternalBatteryStatus {
	LowBattery = 'LOW_BATTERY',
	InternalBatteryTampered = 'INTERNAL_BATTERY_TAMPERED',
}

export interface DeviceHealth {
	deviceStatus: DeviceStatus;
	timeSlot: TimeSlot;
}

export enum DeviceStatus {
	DeviceStatusGood = 'DEVICE_STATUS_GOOD',
}
export enum AccidentStatus {
	DeviceStatusGood = 'ROLLOVER',
	HighGForce = 'HIGH_G_FORCE',
}

export interface Engine {
	engineStatus: EngineStatus;
	timeSlot: TimeSlot;
}

export enum EngineStatus {
	EngineOff = 'ENGINE_OFF',
	EngineOn = 'ENGINE_ON',
}

export interface FloatMetric {
	value: number;
	timeSlot: TimeSlot;
}
export interface StringMetric {
	value: string;
	timeSlot: TimeSlot;
}

export enum Value {
	Accident = 'Accident',
	DigitalInputChanged = 'Digital Input Changed',
	ElapsedTime = 'Elapsed time',
	Empty = '',
	EndOfTrip = 'End of trip',
	Heartbeat = 'Hertbeat',
}

export interface Sprayer {
	sprayerStatus: SprayerStatus;
	timeSlot: TimeSlot;
}

export enum SprayerStatus {
	SprayerOff = 'SPRAYER_OFF',
	SprayerOn = 'SPRAYER_ON',
}

export interface ResponseStatus {
	status: string;
	statusReason: string;
	errorCode: string;
	internalErrorCode: number;
}
export interface BasicMetricData {
	startTime: string;
	endTime: string;
	height: number;
	offset: number;
	metadata: Array<{ label: string; value: string }>;
}
export interface ProcessedGraphMetricData {
	staticData: StaticGraphicalData;
	graphData: BasicMetricData[];
}
export interface StaticGraphicalData {
	icon: {
		url: string;
		iconType: MarkerIconType;
		desc?: string | undefined;
	};
	backgroundColor: string;
}
export interface CombinedMetricsData {
	ENGINE_ON: BasicMetricData[];
	ENGINE_OFF: BasicMetricData[];
	SPRAYER_ON: BasicMetricData[];
	SPRAYER_OFF: BasicMetricData[];
	ACCIDENT_STATUS: BasicMetricData[];
	INTERNAL_BATTERY_LOW: BasicMetricData[];
	MACHINE_MOVING: BasicMetricData[];
	EXTERNAL_POWER_DISCONNECTED: BasicMetricData[];
}
export interface CombinedGraphicalMetricData {
	ACCIDENT_STATUS: ProcessedGraphMetricData;
	EXTERNAL_POWER_DISCONNECTED: ProcessedGraphMetricData;
	EXTERNAL_POWER_DISCONNECTED_AND_MOVING: ProcessedGraphMetricData;
	INTERNAL_BATTERY_LOW: ProcessedGraphMetricData;
	INTERNAL_BATTERY_LOW_AND_MOVING: ProcessedGraphMetricData;
	ENGINE_OFF: ProcessedGraphMetricData;
	SPRAYER_ON: ProcessedGraphMetricData;
	SPRAYER_ON_AND_MOVING: ProcessedGraphMetricData;
	MACHINE_MOVING: ProcessedGraphMetricData;
	ENGINE_ON: ProcessedGraphMetricData;
}
export enum MetricTypesEnum {
	METRIC_TYPE_ENGINE = 'METRIC_TYPE_ENGINE',
	METRIC_TYPE_ACCIDENT_STATUS = 'METRIC_TYPE_ACCIDENT_STATUS',
	METRIC_TYPE_SPRAYER = 'METRIC_TYPE_SPRAYER',
	METRIC_TYPE_HEALTH_STATUS = 'METRIC_TYPE_HEALTH_STATUS',
	METRIC_TYPE_EXTERNAL_POWER_STATUS = 'METRIC_TYPE_EXTERNAL_POWER_STATUS',
	METRIC_TYPE_IGNITION_STATUS = 'METRIC_TYPE_IGNITION_STATUS',
	METRIC_TYPE_INTERNAL_BATTERY_STATUS = 'METRIC_TYPE_INTERNAL_BATTERY_STATUS',
	METRIC_TYPE_NETWORK_STATUS = 'METRIC_TYPE_NETWORK_STATUS',
	METRIC_TYPE_SPEED_LIMIT_STATUS = 'METRIC_TYPE_SPEED_LIMIT_STATUS',
	METRIC_TYPE_TOWING_STATUS = 'METRIC_TYPE_TOWING_STATUS',
	METRIC_TYPE_BATTERY_PERCENTAGE = 'METRIC_TYPE_BATTERY_PERCENTAGE',
	METRIC_TYPE_INTERNAL_BATTERY_VOLTAGE = 'METRIC_TYPE_INTERNAL_BATTERY_VOLTAGE',
	METRIC_TYPE_EXTERNAL_VOLTAGE = 'METRIC_TYPE_EXTERNAL_VOLTAGE',
	METRIC_TYPE_INTERNAL_TEMP = 'METRIC_TYPE_INTERNAL_TEMP',
	METRIC_TYPE_GSM_SIGNAL_STRENGTH = 'METRIC_TYPE_GSM_SIGNAL_STRENGTH',
	METRIC_TYPE_SPEED = 'METRIC_TYPE_SPEED',
	METRIC_TYPE_LOGS_REASONS = 'METRIC_TYPE_LOGS_REASONS',
}
